// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2dpXT","addWidgetButton":"Header_addWidgetButton__2Kx-w","dashboardTabs":"Header_dashboardTabs__1d83M","active":"Header_active__a3kgX"};